module.exports = __webpack_public_path__ + "img/icon_2_49.13f9602b.png";